import * as contentTypeParser from 'content-type';
import mime from 'mime/lite';

import { extname } from '@gitbook/util-files';

export const DEFAULT_CONTENT_TYPE = 'application/octet-stream';

/**
 * Normalize a content type to strip the charset.
 */
export function normalizeContentType(contentType: string): string {
    return contentTypeParser.parse(contentType).type;
}

/**
 * Get content type of a file using its extension.
 */
export function getContentTypeFromPath(pathname: string): string {
    return normalizeContentType(mime.getType(extname(pathname)) || DEFAULT_CONTENT_TYPE);
}

/**
 * Get content type of a url using its extension.
 */
export function getContentTypeFromURL(uri: string): string {
    const url = new URL(uri);
    return getContentTypeFromPath(url.pathname);
}

/**
 * Get extension from a content type.
 */
export function getExtensionForContentType(type: string, defaultExt = 'bin'): string {
    return mime.getExtension(type) || defaultExt;
}
